import React from 'react'
import { flexRender } from '@tanstack/react-table'
import { ParseKeys } from 'i18next'
import { useTranslation } from 'react-i18next'
import { TableHeadProps } from './types'
import { tableHead } from './config'
import { ArrowUpSVG } from '~/shared/ui/SVG/ArrowUpSVG'

export function TableHead<T>({
  className,
  columns = [],
  aroundwithout = true,
  variant = 'default',
  border,
  sortConfig,
  handleSort,
  sortEnabled,
}: TableHeadProps<T>) {
  const { t } = useTranslation()

  return (
    <thead className={`${tableHead({ variant, border })} ${className}`}>
      {columns.map((headerGroup) => {
        return (
          <React.Fragment key={headerGroup.id}>
            <tr>
              {headerGroup.headers.map((header, index) => {
                const isFirstHeader = index === 0
                const isLastHeader = index === headerGroup.headers.length - 1
                const isSorted = sortConfig?.index === index
                const isSortable = Boolean(
                  sortEnabled &&
                  'accessorKey' in header.column.columnDef &&
                  header.column.columnDef.accessorKey,
                )
                const headerStyles = {
                  width: header.getSize(),
                  borderTopLeftRadius:
                    aroundwithout && isFirstHeader ? '10px' : '0',
                  borderTopRightRadius:
                    aroundwithout && isLastHeader ? '10px' : '0',
                  fontWeight: 'normal',
                  color: 'black',
                  padding: isFirstHeader ? '0px 20px' : '0px 5px',
                  cursor: isSortable ? 'pointer' : '',
                }
                if (header.id === 'actions') {
                  headerStyles.padding = '0px 30px'
                }

                return (
                  <th
                    onClick={() => isSortable && handleSort?.(index)}
                    key={header.id}
                    colSpan={header.colSpan}
                    {...(aroundwithout ? { aroundwithout: 'true' } : {})}
                    style={{
                      ...headerStyles,
                    }}
                    scope="col"
                  >
                    <div
                      style={{
                        display: 'flex',
                        gap: '4px',
                      }}
                    >
                      {flexRender(
                        typeof header.column.columnDef.header === 'string'
                          ? t(header.column.columnDef.header as ParseKeys)
                          : header.column.columnDef.header,
                        header.getContext(),
                      )}
                      {isSortable && (
                        <ArrowUpSVG
                          style={{
                            transform:
                              isSorted && sortConfig.sortBy === 'desc'
                                ? 'rotate(180deg)'
                                : 'none',
                            transition: 'transform 0.2s',
                            opacity: isSorted ? 1 : 0.5,
                          }}
                        />
                      )}
                    </div>
                  </th>
                )
              })}
            </tr>
            <tr>
              <td
                colSpan={headerGroup.headers.reduce(
                  (acc, header) => acc + header.colSpan,
                  0,
                )}
              />
            </tr>
          </React.Fragment>
        )
      })}
    </thead>
  )
}
